import { FaPaperclip } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardArquivoAgendamento = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.atendimento_info;

    if (!info) return null;

    const titulo = `Novo arquivo em agendamento`;
    const descricao = `Paciente: ${info.beneficiario_nome} - Programa: ${info.programa_nome}`;
    
    let dataDisplay = notif.data_criacao || "-";
    
    if (dataDisplay !== "-" && !dataDisplay.includes("/")) {
        try {
            dataDisplay = new Date(dataDisplay).toLocaleString("pt-BR");
        } catch (e) {
            // Mantém original se falhar
        }
    }

    const handleClick = () => {
        const identificador = info.uuid || info.id;
        navigate(`/atendimentos/edit/${identificador}/?aba=agendamentos`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaPaperclip />}
            color="info"
            text="text-info"
            label="Novo Arquivo"
            titulo={titulo}
            descricao={descricao}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardArquivoAgendamento;
